import { c as _c } from "react/compiler-runtime";
import { Box, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
interface StatsCardProps {
  label?: string;
  statistic?: string;
  iconURL?: string;
  id?: string;
  platform?: string;
}
interface ColorTheme {
  bgColor?: string;
  bgGradient?: string;
  color?: string;
}
const platformThemes: Record<string, ColorTheme> = {
  Clarity: {
    bgColor: 'cyan.muted',
    color: 'BrightBlue'
  },
  CustomerService: {
    bgColor: 'purple.muted',
    color: 'LightPurple'
  },
  Fundable: {
    bgColor: 'blue.muted',
    color: 'BrightGreen'
  },
  Launchrock: {
    bgColor: 'red.muted',
    color: 'LightRed'
  },
  Outcomes: {
    bgColor: 'pink.muted',
    color: 'LightPink'
  },
  Startups: {
    bgColor: 'orange.muted',
    color: 'LightOrange'
  }
};
const StatsCard: React.FC<StatsCardProps> = t0 => {
  const $ = _c(29);
  const {
    label,
    statistic,
    iconURL,
    platform
  } = t0;
  let t1;
  if ($[0] !== platform) {
    t1 = platform ? platformThemes[platform] : {};
    $[0] = platform;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const theme = t1;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t2 = theme.bgGradient;
  const t3 = theme.bgColor;
  let t4;
  if ($[2] !== getBreakpointValue) {
    t4 = getBreakpointValue({
      base: 5,
      md: 10
    });
    $[2] = getBreakpointValue;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== getBreakpointValue) {
    t5 = getBreakpointValue({
      base: "4em",
      md: "6em"
    });
    $[4] = getBreakpointValue;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== iconURL || $[7] !== t5 || $[8] !== theme.color) {
    t6 = <Image boxSize={t5} color={theme.color} src={iconURL} />;
    $[6] = iconURL;
    $[7] = t5;
    $[8] = theme.color;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = theme.color;
  let t8;
  if ($[10] !== getBreakpointValue) {
    t8 = getBreakpointValue({
      base: "3xl",
      md: "4xl"
    });
    $[10] = getBreakpointValue;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== statistic || $[13] !== t8 || $[14] !== theme.color) {
    t9 = <Heading color={t7} lineHeight="shorter" size={t8}>{statistic}</Heading>;
    $[12] = statistic;
    $[13] = t8;
    $[14] = theme.color;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== getBreakpointValue || $[17] !== label || $[18] !== theme.color) {
    t10 = label && <Text color={theme.color} fontSize={getBreakpointValue({
      base: "md",
      md: "2xl"
    })} opacity={0.5} textStyle="labelLg">{label}</Text>;
    $[16] = getBreakpointValue;
    $[17] = label;
    $[18] = theme.color;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <Box>{t9}{t10}</Box>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t4 || $[25] !== t6 || $[26] !== theme.bgColor || $[27] !== theme.bgGradient) {
    t12 = <VStack alignItems="flex-start" alignSelf="stretch" bg={t2} bgColor={t3} borderRadius="2xl" boxShadow="sm" gap={t4} justify="space-between" padding={6} width="full">{t6}{t11}</VStack>;
    $[23] = t11;
    $[24] = t4;
    $[25] = t6;
    $[26] = theme.bgColor;
    $[27] = theme.bgGradient;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default StatsCard;